/**
 *
 *
 *
 * @param {*} [productList=[]]
 * @param {*} productId
 * @param {string} [code=""]
 * @description 添加商品关联信息
 */
export function addProductRelation(productList = [], productId, code = "") {
    let temp = [];
    productList.forEach((item) => {
        if (item.productId == productId) {
            let { relation = {} } = item;
            item.relation = Object.assign(
                { ...relation },
                {
                    customCode: code,
                }
            );
        }
        temp.push(item);
    });
    return temp;
}

/**
 *
 *
 *
 * @param {*} [productList=[]]
 * @param {*} productId
 * @description 添加商品关联信息
 */
export function deleteProductRelation(productList = [], productId) {
    let temp = [];
    productList.forEach((item) => {
        if (item.productId == productId) {
            let { relation = {} } = item;
            if (relation.customCode) {
                delete relation.customCode;
            }
            item.relation = relation;
        }
        temp.push(item);
    });
    return temp;
}
